import script from "./RenderBlog.vue?vue&type=script&setup=true&lang=js"
export * from "./RenderBlog.vue?vue&type=script&setup=true&lang=js"

import "./RenderBlog.vue?vue&type=style&index=0&id=28c4fe2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c4fe2a"]])

export default __exports__